import { PageHero } from "@/components/Sections";

export default function Terms() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title="Terms of"
        accent="Use."
        subtitle="The terms that apply when you use Bronto Cosmos."
      />
      <section className="max-w-3xl mx-auto px-6 pb-24 text-white/75 leading-relaxed space-y-6 text-[15px]">
        <p>Last updated: February 2026.</p>
        <h2 className="display text-2xl text-white">Acceptance</h2>
        <p>By accessing or using Bronto Cosmos, you agree to these Terms of Use. If you do not agree, please do not use the platform.</p>
        <h2 className="display text-2xl text-white">Use of the platform</h2>
        <p>You agree to use Bronto Cosmos for lawful purposes only and not to interfere with the operation of the platform, attempt to gain unauthorized access, or misuse the contact form to send spam or unlawful content.</p>
        <h2 className="display text-2xl text-white">Third-party content</h2>
        <p>Bronto Cosmos displays imagery and data from open scientific sources. Such imagery is generally available for educational or informational purposes; some items may carry attribution requirements held by their respective originating institutions. Bronto Cosmos does not claim ownership of such material.</p>
        <h2 className="display text-2xl text-white">Intellectual property</h2>
        <p>The Bronto Cosmos name, design, and original editorial content are the property of Bronto Intelligence Private Limited. You may not reproduce or redistribute substantial portions of the original content without permission.</p>
        <h2 className="display text-2xl text-white">No warranty</h2>
        <p>The platform is provided on an &quot;as is&quot; basis. While we work to keep the information accurate, Bronto Cosmos makes no warranty that the platform will be free from errors or interruptions.</p>
        <h2 className="display text-2xl text-white">Limitation of liability</h2>
        <p>To the maximum extent permitted by law, Bronto Intelligence Private Limited shall not be liable for indirect, incidental, or consequential damages arising from the use of the platform.</p>
        <h2 className="display text-2xl text-white">Changes</h2>
        <p>These terms may be updated from time to time. Continued use of the platform after changes are posted constitutes acceptance of the revised terms.</p>
        <h2 className="display text-2xl text-white">Contact</h2>
        <p>For questions about these terms, email info@brontointelligence.com.</p>
      </section>
    </>
  );
}
